import { MailNurture } from 'almanac-ui/icons/blaze/32'
import { object, string } from 'yup'
import { FormSchema } from '../Wizard/Form/Types'
import { additionalInfo } from './shared/additionalInfo'
import { audience } from './shared/audience'
import { avoid } from './shared/avoid'
import { callToAction } from './shared/callToAction'
import { count } from './shared/count'
import { includeImages } from './shared/includeImages'
import { productDescription } from './shared/productDescription'
import { productName } from './shared/productName'
import { brandVoiceId, tone } from './shared/voiceTones'
import { safify } from './utils/safify'
import { sourceMaterialIds } from './shared/sourceMaterials'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { GenerationType } from 'components/BlazeCommandLine/api/createDocGenerationRequest'
import { MultiStepSchema, StepSchema } from 'components/Wizards/schemas/Types'
import { SelectImages } from 'components/Wizards/schemas/shared/selectImages'
import { brandKitId } from './shared/brandKitId'
import { language } from './shared/language'
import { TextChannels } from '../../../constants'

const meta = {
  type: ChannelType.NurtureEmailSequence,
  steps: ['Email Context & Goals', 'Generate Emails'],
  submitLabel: 'Generate Emails',
  icon: MailNurture,
  title: TextChannels[ChannelType.NurtureEmailSequence].name,
  previewUrl:
    'https://res.cloudinary.com/almanac/image/upload/v1710183789/Home%20Card%20Previews/puqlfkpxcgs9zgvdha8o.png',
}

const fields = {
  count: count
    .default(3)
    .min(1)
    .max(7)
    .meta({ label: 'How many emails do you want in this nurture sequence?', autoFill: true }),
  goal: string()
    .default('')
    .required()
    .meta({
      label: 'Describe the objective of your campaign',
      placeholder: 'Describe the goal(s) of your email sequence',
      snippets: true,
      rows: 3,
      generate: true,
      typeahead: true,
      generationType: meta.type,
    })
    .transform(safify),
  audience: audience.meta({
    label: 'Who is the target audience?',
    placeholder: 'Who is the desired reader of your emails?',
  }),
  product_name: productName,
  product_description: productDescription,
  brand_voice_id: brandVoiceId,
  brand_kit_id: brandKitId,
  tone,
  source_material_ids: sourceMaterialIds,
  include_images: includeImages,
  language,
  length: string()
    .default('')
    .meta({
      label: 'Word count per email',
      placeholder: 'Approximate length for each email',
      collapsible: true,
      autoFill: true,
    })
    .transform(safify),
  call_to_action: callToAction.meta({ collapsible: true }),
  avoid: avoid.meta({ collapsible: true }),
  additional_info: additionalInfo.meta({ collapsible: true }),
}

export const NurtureEmailSequenceSchema = object(fields).meta(meta) as FormSchema<GenerationType | ChannelType>

export const NurtureEmailSequenceMultiStepSchema: MultiStepSchema<ChannelType.NurtureEmailSequence> = {
  steps: [
    NurtureEmailSequenceSchema.omit(['include_images']).meta({
      title: 'Purpose & Goals',
      submitLabel: 'Select Images',
    }) as StepSchema,
    SelectImages.meta({ submitLabel: meta.submitLabel, type: meta.type }) as StepSchema,
  ],
  meta: {
    ...meta,
    type: ChannelType.NurtureEmailSequence,
    channel: ChannelType.NurtureEmailSequence,
  },
}
